// Copyright 2026. WebPros International GmbH. All rights reserved.

export const HIGH_AVAILABILITY_HISTORY = {
    RETRY_BUTTON: 'ha-activities-retry',
    MOVE_BACK_BUTTON: 'ha-activities-move-back',
    ROW_MOVE_BACK_BUTTON: 'ha-activities-row-move-back',
    FILTERS_BUTTON: 'ha-activities-filters',
};
